<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear equipo</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-col cols="12">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        :to="'lista-equipo'"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-col>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    label="Equipo"
                                    v-model="equipo.id_oficial"
                                    :items="oficiales"
                                    item-text="name"
                                    item-value="id"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete
                                    label="Seleccionar peón"
                                    v-model="id_peon"
                                    :items="peones"
                                    item-text="name"
                                    item-value="id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-btn
                                    color="primary"
                                    @click="agregarPeon"
                                    white-text
                                    >Agregar al equipo</v-btn
                                >
                            </v-col>
                            <v-col cols="12">
                                <h3>Peones asociados al equipo</h3>
                                <v-data-table
                                    :items="this.equipo.peones"
                                    dense
                                    :headers="headers"
                                >
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                            @click="openDeleteDialogPeon(item)"
                                            small
                                            class="mr-2"
                                            color="red"
                                            style="font-size: 25px"
                                            title="BORRAR"
                                            >mdi-trash-can</v-icon
                                        >
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-col cols="12">
                            <v-textarea
                                outlined
                                label="Observaciones"
                                v-model="equipo.observaciones"
                            ></v-textarea>
                        </v-col>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-equipo">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!equipo.id"
                                    @click="saveequipo"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="equipo.id"
                                    @click="saveequipo"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="equipo.id"
                                    @click="dialog_delete = true"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <!-- Confirmacion de eliminacion de equipo-->
        <DeleteDialog
            v-model="dialog_delete"
            @delete="deleteequipo"
        ></DeleteDialog>

        <!-- Confirmacion de eliminacion de peon asociado al equipo -->
        <DeleteDialog
            v-model="isDeleteDialogPeon"
            @delete="deletePeon"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";

export default {
    components: {
        DeleteDialog,
    },
    data() {
        return {
            dialog_delete: false,
            isDeleteDialogPeon: false,
            selectedItemPeon: null,

            id_peon: null,
            peones: [],
            oficiales: [],
            menu: false,
            headers: [
                { text: "Nombre", value: "peon.name", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            equipo: {
                id: null,
                email: "",
                telefono: "",
                direccion: "",
                peones: [],
            },
        };
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        this.getOficiales();
        this.gtePeones();
        if (this.$route.query.id) {
            this.getequipo(this.$route.query.id);
        }
    },
    methods: {
        openDeleteDialogPeon(item) {
            this.selectedItemPeon = item;
            this.isDeleteDialogPeon = true;
        },
        deletePeon() {
            let index = this.equipo.peones.indexOf(this.selectedItemPeon);
            this.equipo.peones.splice(index, 1);
            this.isDeleteDialogPeon = false;
        },
        agregarPeon() {
            let peon = this.peones.find(
                (element) => element.id == this.id_peon
            );
            this.equipo.peones.push({
                id_peon: this.id_peon,
                peon: peon,
            });
            this.id_peon = null;
        },
        getOficiales() {
            axios.get(`api/get-oficiales`).then(
                (res) => {
                    this.oficiales = res.data;
                },
                (res) => {}
            );
        },
        gtePeones() {
            axios.get(`api/get-peones`).then(
                (res) => {
                    this.peones = res.data;
                },
                (res) => {}
            );
        },
        getequipo(equipo_id) {
            axios.get(`api/get-equipo/${equipo_id}`).then(
                (res) => {
                    this.equipo = res.data;
                },
                (res) => {}
            );
        },

        saveequipo() {
            axios
                .post("api/save-equipo", this.equipo)
                .then((res) => {
                    this.$router.push("lista-equipo");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteequipo() {
            axios.get(`api/delete-equipo/${this.equipo.id}`).then(
                (res) => {
                    this.$router.push("lista-equipo");
                },
                (res) => {}
            );
        },
        save(date) {
            this.$refs.menu.save(date);
        },
    },
    filters: {},
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
    },
};
</script>
